import React, { Component } from 'react';
import * as _ from 'lodash'
// import './style.css';

import SurveySection from '../SurveySection'

import State from '../State'

class Survey extends Component {

  constructor(props) {
    super(props)

    this.sections = [
      'moisture',
      'occupancy',
      'building condition',
      'heating',
      'ventilation'
    ]
  }

  render() {
    if(State.ui.intro) {
      return <div></div>
    }

    const sections = _.map(this.sections, (sectionId, i) => {
      const isLastSection = i === this.sections.length - 1
      return <SurveySection key={sectionId} sectionIndex={i} sectionId={sectionId} isLastSection={isLastSection} />
    })

    return (
      <div className="survey">{sections}</div>
    );
  }
}

export default Survey;



// WEBPACK FOOTER //
// ./src/Survey/index.js